import { baseUri } from '@gonfalon/constants/constants';
import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';

import { Jumbo } from '#components/Jumbo';

const authenticationDocLink = getDocumentationUrl('home/account/secure');

type CouldNotConnectProps = {
  error: ImmutableServerError;
};

export function CouldNotConnect({ error }: CouldNotConnectProps) {
  const status = error.get('status');
  let explanation: string = msg('ui.connectionError.body');
  let action;
  if (status === 403) {
    explanation = msg('ui.connectionError.originMismatch', { baseUri: baseUri() });
    action = (
      <div>
        <Message
          id="ui.connectionError.learnMore"
          values={{ link: (chunks) => <a href={authenticationDocLink}>{chunks}</a> }}
        />
      </div>
    );
  }
  return <Jumbo title={msg('ui.connectionError.heading')} lead={explanation} actions={action} isError />;
}
